import { RootState } from "@/redux/store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import * as API from "../@api/update";

export const getCategories = createAsyncThunk<any, void, { state: RootState }>(
  "categories/getCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.getCategories();
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

export const getDynamicFieldsByCategory = createAsyncThunk<
  any,
  string,
  { state: RootState }
>(
  "fieldsByCategory/getDynamicFieldsByCategory",
  async (category_id, { rejectWithValue }) => {
    try {
      const response = await API.getDynamicFieldsByCategory(category_id);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

export const getSubSubCategories = createAsyncThunk<
  any,
  void,
  { state: RootState }
>("categories/getSubSubCategories", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get_sub_sub_Categories();
    return response;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data || error?.message);
  }
});

export const getCompanies = createAsyncThunk<
  any,
  { searchTerm?: string; page?: string; limit?: string } | undefined,
  { state: RootState }
>("companyList", async (pagination, { rejectWithValue }) => {
  try {
    const response: any = await API.getCompanies({
      searchTerm: pagination?.searchTerm,
      page: pagination?.page,
      limit: pagination?.limit,
    });

    window?.scrollTo?.({ top: 0, left: 0, behavior: "auto" });

    return response;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data || error?.message);
  }
});

export const getCompany = createAsyncThunk<any, void, { state: RootState }>(
  "companyDetails/getCompany",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.getCompany();
      window?.scrollTo?.({ top: 0, left: 0, behavior: "auto" });
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

export const updateCompanyDetails = createAsyncThunk<
  any,
  FormData,
  { state: RootState }
>(
  "companyDetails/updateCompanyDetails",
  async (formValue, { rejectWithValue, getState }) => {
    const companyDetails = (getState() as any)?.user_company?.companyDetails;

    try {
      const response: any = await API.updateCompanyDetails(formValue);

      toast.success(response?.meta?.message as string, {
        classNames: {
          toast: "!bg-green-500 !text-white",
        },
      });

      window?.scrollTo?.({ top: 0, left: 0, behavior: "auto" });

      return response;
    } catch (error: any) {
      toast.error(error?.meta?.message as string, {
        classNames: {
          toast: "!bg-red-500 !text-white",
        },
      });

      return rejectWithValue(companyDetails || error?.message);
    }
  }
);

export const companyEmailVerifyInitiate = createAsyncThunk<
  any,
  { email: string;},
  { state: RootState }
>(
  "emailVerificationInitiate/companyEmailVerifyInitiate",
  async (payload, { rejectWithValue }) => {
    try {
      const response: any = await API.companyEmailVerifyInitiate(payload);

      toast.success(response?.meta?.message as string, {
        classNames: {
          toast: "!bg-green-500 !text-white",
        },
      });

      return response;
    } catch (error: any) {
      toast.error(error?.meta?.message as string, {
        classNames: {
          toast: "!bg-red-500 !text-white",
        },
      });

      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

export const companyEmailVerify = createAsyncThunk<
  any,
  { email_otp: string },
  { state: RootState }
>(
  "emailVerify/companyEmailVerify",
  async (payload, { rejectWithValue }) => {
    try {
      const response: any = await API.companyEmailVerify(payload);

      toast.success(response?.meta?.message as string, {
        classNames: {
          toast: "!bg-green-500 !text-white",
        },
      });

      return response;
    } catch (error: any) {
      toast.error(error?.meta?.message as string, {
        classNames: {
          toast: "!bg-red-500 !text-white",
        },
      });

      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

export const thunks = {
  getCategories,
  getSubSubCategories,
  getCompanies,
  getCompany,
  updateCompanyDetails,
  companyEmailVerifyInitiate,
  companyEmailVerify
};
